import * as React from 'react';
import { Head } from '@inertiajs/react';
import { LinkedText } from './LinkedText';

interface SEOBlockProps {
  canonical: string;
  title: string;
  description: string;
  seo: string;
  jsonLd: Record<string, unknown>;
}

export function SEOBlock({ canonical, title, description, seo, jsonLd }: SEOBlockProps) {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <link rel="canonical" href={canonical} />
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Head>
      <section className="whyus-seo">
        <style>{`
          .whyus-seo {
            padding: 48px 24px;
            background: #fafaf7;
            border-top: 1px solid #eee;
          }
          .whyus-seo-inner {
            max-width: 720px;
            margin: 0 auto;
          }
          .whyus-seo h2 {
            font-size: 20px;
            font-weight: 700;
            color: #666;
            margin: 0 0 12px;
          }
          .whyus-seo p {
            font-size: 15px;
            color: #666;
            line-height: 1.7;
            margin: 0;
          }
        `}</style>
        <div className="whyus-seo-inner">
          <h2>Ecommerce de frutas y verduras en Córdoba</h2>
          <p><LinkedText text={seo} /></p>
        </div>
      </section>
    </>
  );
}
